import { render } from "./PrivacyPolicy.vue.js?vue&type=template&id=62bbcef8&scoped=true!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PrivacyPolicy.vue?vue&type=template&id=62bbcef8&scoped=true"
import script from "./PrivacyPolicy.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PrivacyPolicy.vue?vue&type=script&lang=js"

import "./PrivacyPolicy.vue.scss?vue&type=style&index=0&id=62bbcef8&scoped=true&lang=scss!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PrivacyPolicy.vue?vue&type=style&index=0&id=62bbcef8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62bbcef8"],['__file',"src/Web/scripts/pages/PrivacyPolicy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62bbcef8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62bbcef8', __exports__)) {
    api.reload('62bbcef8', __exports__)
  }
  
  module.hot.accept("./PrivacyPolicy.vue.js?vue&type=template&id=62bbcef8&scoped=true!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PrivacyPolicy.vue?vue&type=template&id=62bbcef8&scoped=true", () => {
    api.rerender('62bbcef8', render)
  })

}


export default __exports__